import React from 'react';
import { Breakpoint } from '@moda/om';
import { MobileNav } from '../MobileNav';
import { DesktopNavigationProvider } from '../DesktopNavigation/DesktopNavigationProvider';
import { DesktopSiteNav } from './DesktopSiteNav';

import './SiteNav.scss';

export const SiteNav: React.FC = () => {
  return (
    <div className="SiteNav">
      <Breakpoint gt="md">
        <DesktopNavigationProvider>
          <DesktopSiteNav />
        </DesktopNavigationProvider>
      </Breakpoint>

      <Breakpoint lt="md">
        <MobileNav />
      </Breakpoint>
    </div>
  );
};
